import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KettoAssuredComponent } from './components/ketto-assured/ketto-assured.component';
import { SharedModule } from '../../shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    SharedModule
  ],
  declarations: [KettoAssuredComponent],
  exports: [KettoAssuredComponent],
})
export class KettoAssuredModule { }
